// extracted by mini-css-extract-plugin
module.exports = {"ok":"TableCellColors_ok__MEcAH","ko":"TableCellColors_ko__L72Xi"};